var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSfp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.232 18.376v2.12c0 5.887-8.646 9.276-11.296 10.175l-.964.33v-3.663l.471-.175c4.123-1.534 8.283-4.19 8.283-6.667v-2.119h3.506zM16.138 1l3.533 1.077v3.737l-3.532-1.08-.23.07v8.408h3.763v3.465h-3.763v14.272l-.981-.363a33.196 33.196 0 0 1-2.098-.86l-.427-.192V2.14L16.14 1zM11.292 2.49v3.722L6.505 7.68v5.532h4.787v16.024l-1.06-.539C6.932 27.02 3 24.19 3 20.24v-1.864h3.505v1.863c0 .816.43 1.675 1.282 2.56v-6.123H3V5.02l8.292-2.529zm9.444-.087L29.232 5v11.677h-4.989v5.056s-1.115 1.444-3.504 2.654l-.004-17.21V2.402zm3.507 4.808v6.002h1.483V7.663l-1.483-.452z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfp);
export default __webpack_public_path__ + "static/media/SFP.e84d6a7898e96af8c7a2519bc95987b4.svg";
export { ForwardRef as ReactComponent };